import React from 'react';
import { replacePathParams } from '@utils/replacePathWithParams';
import { routesPath } from '@router/routes';
import { FileDxaIcon } from '@dynamika-shared/ui/icons';
import { Link } from 'react-router-dom';
import { OHIFImagingLabel } from '@dynamika-shared/types/imagingLabels';
type DxaButtonProps = {
  clinicalTrialId?: string;
  taskId?: string;
  dxaLabels?: OHIFImagingLabel[];
};
export const DxaButton = ({
  clinicalTrialId,
  taskId,
  dxaLabels,
}: DxaButtonProps) => {
  if (!clinicalTrialId || !taskId || !dxaLabels?.length) {
    return null;
  }
  return (
    <Link
      className='min-w-[12rem] rounded-lg ml-1 bg-vividTangelo p-[1.2rem] text-white flex items-center justify-center text-1624 px-1.5 py-1.5 font-semibold hover:bg-dodgerBlue hover:text-white'
      to={replacePathParams(routesPath.qcTaskDXA, {
        id: clinicalTrialId,
        taskId,
      })}
    >
      <FileDxaIcon className='mr-[.5rem]' />
      DXA QC
    </Link>
  );
};
